import { render } from "./SenaraiNotis6A.vue?vue&type=template&id=5588c03d"
import script from "./SenaraiNotis6A.vue?vue&type=script&lang=js"
export * from "./SenaraiNotis6A.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__